import React from 'react';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { registerables, Chart } from 'chart.js';
import { useIntl } from 'react-intl';
Chart.register(...registerables);

const UserTrainingsPerDayAndMonthChart = ({ data }) => {
  const labels = data.map((item) => `${item.yearMonthDay}`); // Generate labels for x-axis
  const userCounts = data.map((item) => item.trainingCount); // Get trainingCount values for y-axis
  const intl = useIntl();

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: intl.formatMessage({ id: 'userTracking.perDayAndMonth.label.title', defaultMessage: 'Trainings Per Day and Month'}),
        data: userCounts,
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    indexAxis: 'x', // Use 'x' for horizontal bar chart
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Bar data={chartData} options={chartOptions} />;
};
  
UserTrainingsPerDayAndMonthChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string,
      month: PropTypes.string,
      yearMonthDay: PropTypes.string,
      trainingCount: PropTypes.number,
    })
  ),
};

export { UserTrainingsPerDayAndMonthChart };
